export default __webpack_public_path__ + "static/media/first_block_image.0187ec98.webp";